@if (displayConfig()?.errorCount > 0 || displayConfig()?.warningCount > 0) {
    <div
        class="quote-error-indicator"
        [class.quote-error-indicator--has-errors]="displayConfig()?.errorCount > 0"
        [class.quote-error-indicator--warnings-only]="displayConfig()?.errorCount === 0 && displayConfig()?.warningCount > 0"
        [pTooltip]="combinedTooltip()"
        tooltipPosition="bottom"
        (click)="openValidationErrorsDialog()">
        @if (displayConfig()?.errorCount > 0) {
            <span class="quote-error-indicator__badge quote-error-indicator__badge--error">
                <i class="pi pi-exclamation-circle"></i>
                <span>{{ displayConfig()?.errorCount }}</span>
            </span>
        }
        @if (displayConfig()?.warningCount > 0) {
            <span class="quote-error-indicator__badge quote-error-indicator__badge--warning">
                <i [class]="displayConfig()?.incompleteIcon"></i>
                <span>{{ displayConfig()?.warningCount }}</span>
            </span>
        }
    </div>
}
@if (isDeveloper()) {
    <i
        class="yllw-quote-toolbar__utility-btn pi pi-refresh"
        [pTooltip]="'QUOTE.DETAIL.REFRESH_QUOTE' | translate"
        tooltipPosition="bottom"
        (click)="onRefreshQuote()"
    ></i>
}
